import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import useSupportChat from 'shared/hooks/useSupportChat';

const CenteringWrapper = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 64px;
`;

const Loader = styled.span`
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: bblFadInOut 1.8s infinite ease-in-out;
  color: ${({ theme }) => theme.palette.secondary.main};
  font-size: 7px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;

  &:before,
  &:after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: bblFadInOut 1.8s infinite ease-in-out;
    content: '';
    position: absolute;
    top: 0;
  }

  &:before {
    left: -3.5em;
    animation-delay: -0.32s;
  }
  &:after {
    left: 3.5em;
  }

  @keyframes bblFadInOut {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
`;

const ClickableText = styled(Typography).attrs(() => ({
  component: 'span',
}))`
  cursor: pointer;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
`;

const EnvInitiatingPage = () => {
  const supportChat = useSupportChat();

  return (
    <CenteringWrapper>
      <Loader />
      <FlexColumn sx={{ gap: 2, alignItems: 'center' }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          Initializing Elementary...
        </Typography>

        <Typography
          sx={{
            whiteSpace: 'pre',
            textAlign: 'center',
            color: 'common.gray2',
          }}
        >
          Elementary is syncing metadata, logs and results from <br /> your data
          warehouse. <br />
          The first sync might take a few minutes.
        </Typography>

        <Typography sx={{ fontWeight: 'bold' }}>
          Having any issues?{' '}
          <ClickableText onClick={supportChat.show}>Contact us</ClickableText>
        </Typography>
      </FlexColumn>
    </CenteringWrapper>
  );
};

export default EnvInitiatingPage;
